export default __webpack_public_path__ + "static/media/pakfon.5a6fa686.png";